module.exports = __webpack_public_path__ + "assets/img/page-title-9d925859.png";